import { tourStep } from './tourRegistry';

export const bandaMusicosSteps = [
  tourStep(
    'musicos-tabs',
    'Mis músicos',
    'La <strong>plantilla</strong> es el censo (quién toca qué). Los <strong>grupos de músicos</strong> agrupan músicos (secciones, junta…) para ensayos y encuestas.',
  ),
  tourStep(
    'musicos-add',
    'Añadir músico',
    'Nombre, instrumento y datos de contacto. Sin al menos un músico no se pueden crear formaciones, ensayos ni actuaciones.',
  ),
  tourStep(
    'musicos-filtros',
    'Buscar y filtrar',
    'Por nombre, instrumento, familia o <strong>estado</strong> (activo = plantilla operativa; inactivo = se conserva pero no se convoca). Al cambiar el estado te pediremos confirmación. Descarga el listado en Excel o PDF.',
  ),
];
